export default (query) => {
    if(!query) return null
    var match = query.match(/(manufacturer|category|brand|product|vehicule):([0-9a-z]+)(.*)?/)
    if (!match) return null
    return {
        type: match[1],
        value: match[2],
        q: match[3] || null
    };
}
